import React from "react";
import CrossIcon from "assets/svg/cross-icon";
import MapPinIcon from "assets/svg/map-pin-icon";
import LinkIcon from "assets/svg/link-icon";
import WhatsAppIcon from "assets/svg/whatsapp-icon";
import ShareBannerImage from "assets/images/sharePopup/share-property-bg.webp";
import { customToast } from "utils/customToast";
import Button from "components/button/Button";
import { getCurrency } from "utils/getCurrency";
import { getFormattedPrice } from "utils/getFormattedPrice";
import { getBillingFrequencyFormat } from "utils/getBillingFrequencyFormat";

export default function GeneralSharePopup({
  isOpen,
  onClose,
  data,
  getShareUrl,
  getWhatsappShareMessage,
  getSubText,
  isShareBtnShow = false,
}) {
  let subText = null;
  if (getSubText) {
    subText = getSubText();
  }

  const address =
    typeof data?.address === "string"
      ? data?.address
      : data?.address?.line1 + " " + data?.address?.line2;
  if (!getSubText) {
    const currency = getCurrency(data?.room_starting_price_currency);
    const price = getFormattedPrice(data?.room_starting_price);
    const billingFrequency = getBillingFrequencyFormat(
      data?.room_starting_price_billing_frequency
    );
    subText = (
      <p className="text-pure-white text-xs">
        From {currency}
        {price} /per {billingFrequency}
        <span className="italic text-pale-gold"> (All-bills Inc.)</span>
      </p>
    );
  }

  const handleCopyLink = async () => {
    try {
      const linkToCopy = getShareUrl();
      await navigator.clipboard.writeText(linkToCopy);
      customToast("Success!", "Link copied to clipboard", "success");
    } catch (err) {
      const linkToCopy = getShareUrl();
      const textArea = document.createElement("textarea");
      textArea.value = linkToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.body.removeChild(textArea);
      customToast("Error!", "Error adding to favorites", "error");
    }
  };

  const handleWhatsAppShare = () => {
    const shareUrl = getShareUrl();
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      `${getWhatsappShareMessage()} ${shareUrl}`
    )}`;
    window.open(whatsappUrl, "_blank");
    onClose();
  };

  if (!isOpen) return null;
  const handleShareVia = () => {
    //  call share func.
  };

  console.log(data, "PopupData");

  return (
    <div
      className="w-full h-full bg-primary-navy-blue/70 fixed inset-0 flex items-center justify-center z-[1000]"
      onClick={onClose}
    >
      <div
        className="backdrop-blur-[40px] w-[375px] h-[450px] relative rounded-[24px] overflow-hidden"
        style={{
          backgroundImage: `url(${ShareBannerImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          border: "2px solid rgba(140, 140, 140, 0.3)",
          boxShadow: "3px 3px 10px rgba(0,0,0,0.25)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClose();
          }}
          className="absolute top-4 right-4 text-pure-white hover:opacity-70 transition-opacity z-20 p-2"
          type="button"
        >
          <CrossIcon className="w-6 h-6" />
        </button>

        <div className="relative z-10 h-full flex flex-col gap-[12px] justify-between p-6">
          <h2 className="text-shadow-[2px 4px 30px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.03)] text-pure-white text-[36px] italic font-pfd font-semibold">
            Share with <br />
            Friends
          </h2>

          <div className="flex items-center gap-[14px]">
            <div
              className="overflow-hidden w-[80px] h-[80px] rounded-[8px] flex items-center justify-center"
              style={{
                filter: "drop-shadow(2.16216px 4.32432px 32.4324px #4C4C4C)",
              }}
            >
              {data?.image?.url && (
                <img
                  src={data?.image?.url}
                  alt={data?.image?.name || data?.name}
                  className="h-full w-full object-cover"
                  fetchPriority="high"
                  loading="eager"
                />
              )}
            </div>
            <div className="flex-1">
              <h3 className="text-pure-white text-[18px] font-medium">
                {data?.name || ""}
              </h3>
              {address && (
                <div className="flex items-center text-pure-white text-sm mb-1 hover:text-red-700 hover:cursor-default hover:animate-jiggle">
                  <MapPinIcon className="w-5 h-5 mr-1" />
                  <span>{address}</span>
                </div>
              )}
              <div className="text-[12px] text-pure-white font-medium">
                {subText}
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center gap-[11px]">
            <div className="flex justify-center gap-3">
              <Button
                innerText={"Copy Link"}
                innerClass={"text-pure-white font-bold text-[16px] shrink-0"}
                outerClass={`w-full h-[50px] flex items-center justify-center border hover:border-secondary-rectangle-one border-pure-white curved-hover rounded-[8px] px-[12px] py-[10px] lg:px-[18px] 2xl:px-[28px] 2xl:py-[12px] bg-transparent`}
                outerStyle={{
                  "--hover-bg-color": "#EB5D37",
                  "--hover-text-color": "#ffffff",
                }}
                onClick={handleCopyLink}
                suffixIcon={LinkIcon}
                iconType="svg"
                iconClass="w-[16px] h-[16px] text-pure-white"
              />

              {isShareBtnShow && (
                <Button
                  innerText={"Share via..."}
                  onClick={handleShareVia}
                  innerClass={"text-pure-white font-bold text-[16px] shrink-0"}
                  outerClass={`w-full h-[50px] flex items-center justify-center border hover:border-secondary-rectangle-one border-pure-white curved-hover rounded-[8px] px-[12px] py-[10px] lg:px-[18px] 2xl:px-[28px] 2xl:py-[12px] bg-transparent`}
                  outerStyle={{
                    "--hover-bg-color": "#EB5D37",
                    "--hover-text-color": "#ffffff",
                  }}
                />
              )}
            </div>
            <Button
              innerText={"WhatsApp"}
              innerClass={"text-whatsapp-green font-bold text-[16px] shrink-0"}
              outerClass={`w-full h-[50px] flex group items-center justify-center border border-whatsapp-green curved-hover rounded-[8px] px-[12px] py-[10px] lg:px-[18px] 2xl:px-[28px] 2xl:py-[12px] bg-transparent`}
              outerStyle={{
                "--hover-bg-color": "#2BD36B",
                "--hover-text-color": "#ffffff",
              }}
              onClick={handleWhatsAppShare}
              suffixIcon={WhatsAppIcon}
              iconType="svg"
              iconClass="w-[16px] h-[16px] text-whatsapp-green group-hover:text-pure-white"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
